var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"name-rules":[{ required: true, message: _vm.$t('compute.text_210') }],"resource":"hosts","status-module":"host"}})
}
var staticRenderFns = []

export { render, staticRenderFns }